module.exports = __webpack_public_path__ + "img/10_pourcent.d949adf3.png";